import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';

@Injectable({
  providedIn: 'root'
})
export class AdminAuthService {
  constructor(private msalService: MsalService) { }

  async getToken(): Promise<string> {
    const accounts = this.msalService.instance.getAllAccounts();
    if (accounts.length > 0) {
      const request = {
        scopes: ['api://65eb4c83-e8a0-43ea-825c-4bc6f2cb8776/api'],
        account: accounts[0]
      };
      try {
        const response: AuthenticationResult = await this.msalService.instance.acquireTokenSilent(request);
        return response.accessToken;
      } catch (error) {
        console.error(error);
        return '';
      }
    }
    return '';
  }
}
